export const RENTAL_STATUS = {
  ONGOING: 1,
  COMPLETED: 2,
  PENDING: 3,
  ASSIGN_TRIKE: 4,
  APPROVED: 5,
  REJECTED: 6,
  DRIVER_CANCEL: 7,
};

export const STANDARD_FEE = 550;
